"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toIdentifiableMap = toIdentifiableMap;
function toIdentifiableMap(identifiables) {
    return identifiables.reduce((map, i) => {
        map[i.id] = i;
        return map;
    }, {});
}
//# sourceMappingURL=Identifiable.js.map